import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getGtnNumberByCollectionPointIDandDate,
    getGoodsTransferDetails
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetEveryDivisionsFromOperationEntitiyID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return divisionArray;
}


async function getGtnNumberByCollectionPointIDandDate(data) {
    var gtnArray = [];
    var model = {
        collectionPointID: parseInt(data.divisionID),
        searchDate: data.searchDate
    }
    const response = await CommonPost('/api/GoodsTransferNote/GetGtnNumberByCollectionPointIDandDate', null, model);
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            gtnArray[item[1]["gtnNumber"]] = item[1]["gtnNumber"]
        }
    }
    return gtnArray;
}



async function getGoodsTransferDetails(data) {
    var model = {
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        searchDate: data.searchDate,
        gtnNumber: data.gtnnumber === "0" ? null : data.gtnnumber
    };
    const response = await CommonPost('/api/GoodsTransferDetails/GetGoodsTransferDetails', null, model);
    return response.data;
}
